<template>
	<div>
		<!-- <div style="width: 94%;border-top-right-radius: 20px;border-top-left-radius: 50px;margin: 0 auto;overflow: hidden;" v-for="(l,a) in shu.shu" :key="a">
			 <el-image :src="l.tu"  style="height:100px;width: 100%;"></el-image>
			 <div style="text-align: left;">{{l.ming}}</div>
			<el-row :gutter="20">
			   <el-col :span="16"><el-progress :text-inside="true" :stroke-width="12" :percentage="50" status="exception"></el-progress></el-col>
			   <el-col :span="8"><div class="grid-content bg-purple">已抢8000件</div></el-col>
			 </el-row>
			 
			 <div style="display: flex; align-items: center; justify-content: space-between;padding-top: 10px;padding-bottom: 5px;">
				 <div>￥{{l.jiage}}  <span>150</span></div>
				 <div><el-button type="danger" round>立即抢</el-button></div>
			 </div>
			<div style="display: flex;align-items: center;justify-content: flex-start;border-top: 2px solid #EBEBEB;">
				<div style="direction: rtl;unicode-bidi: bidi-override;padding: 5px 20px 0 0px;display: inline-block;">
					<el-avatar size="medium" src="https://ossweb-img.qq.com/images/lol/web201310/skin/big10001.jpg" style="position: relative; margin-right: -7.5px;border: 1px solid #EBEBEB;" v-for="(item,i) in list" :key='i'></el-avatar>
				</div>
				<div>共4人购买</div>
			</div>
		</div> -->
		aaaaaa
	</div>
	
<!-- 	<div v-else-if="shu.pailiefangshi==2" class="zidingyi_Shangpin">
		<div class="zidingyi_Shangpin2_box" v-for="(l,a) in shu.shu" :key="a">
			<el-image class="zidingyi_Shangpin2_image" :src="l.tu" fit="fill"></el-image>
			<div class="zidingyi_Shangpin_ming">{{l.ming}}</div>
			<div class="zidingyi_Shangpin_jiage">￥{{l.jiage}}</div>
		</div>
	</div> -->
	
</template>
<script>
	export default {
		name: "Miaosha",
		data() {
			return {
				list:[{},{},{}],
			};
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: "输入文字",
						yangshi: {}
					};
				}
			}
		},

		created() {
			this.CSH();			
		},
		methods: {
			CSH(){
				var that=this;
				if(!this.shu.shu){
					var shu={ye:1,jitiao:6};	
					this.shu.mokuai="limitao";	
					// this.shu.pailiefangshi='2';		
					this.shu.guding='1';						
					this.$post('m=limitao&k=shangpin',shu,function(s) {
						if (s.shi == 1) {	
							that.$set(that.shu, "shu",s.shu.lie);									
						}
					});
				}				
			},
		}
	}
</script>


<style>
</style>
